import React from 'react'
import formatSocialNumber from "../utils/helper/formatSocialNumber";


export default function ProfileCardView(props){
    return(
        <div className="card profile-card">
            <div className="profile-header">
                <div className="profile-pic">
                    <img
                        src={
                            props.profile.hasOwnProperty("avatar")?
                                props.profile.avatar:
                                "https://ui-avatars.com/api/?name=Unknown"
                        }
                        alt="profile picture"
                    />
                </div>
            </div>
            <div className="profile-body">
                <div className="profile-name">
                    {
                        props.profile.hasOwnProperty("avatar")?
                            props.profile.first_name+" "+props.profile.last_name:
                            "First and Last Name"
                    }
                </div>
                <div className="profile-username">
                    {
                        props.profile.hasOwnProperty("avatar")?
                            props.profile.profile_name:
                            "username"
                    }
                </div>
            </div>
            <div className="profile-footer">
                <div>
                    {formatSocialNumber(props.borrower.score)}
                    <span>
                        Borrower
                    </span>
                </div>
                <div>
                    {formatSocialNumber(props.investor.score)}
                    <span>
                        Investor
                    </span>
                </div>
                <div>
                    {formatSocialNumber(Object.keys(props.connection).length)}
                    <span>
                        Circle
                    </span>
                </div>
            </div>
        </div>
    )
}